"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const escapeStringRegex_1 = __importDefault(require("../regex/escapeStringRegex"));
/**
 * Alternate to native String.prototype.split() which, if given a limit, will
 * discard any leftover text once the limit of matches is hit.
 *
 * This function as the name implies keeps that leftover text as the final
 * array element.
 *
 * E.g. splitKeepLeftover("a=b=c=d", '=', 2)); // ['a', 'b', 'c=d']
 *
 * Code provided by: https://stackoverflow.com/a/64296576/1231095
 *
 * @param {string} str
 * @param {string|RegExp} separator - Can be a string or a regex pattern as a string, e.g. '\s{2}'
 * @param {number} limit
 */
exports.default = (str, separator, limit) => {
    if (typeof separator === 'string') {
        separator = (0, escapeStringRegex_1.default)(separator);
    }
    // create regexp obj from separator
    const sep = new RegExp(separator, 'g');
    let whileLimit = limit !== null && limit !== void 0 ? limit : -1;
    const output = [];
    let finalIndex = 0;
    while (whileLimit--) {
        const lastIndex = sep.lastIndex;
        const search = sep.exec(str);
        if (search === null) {
            break;
        }
        finalIndex = sep.lastIndex;
        output.push(str.slice(lastIndex, search.index));
    }
    output.push(str.slice(finalIndex));
    return output;
};
